module.exports = __webpack_public_path__ + "img/brainfit_3.9c1e35d5.jpg";